import React from 'react';
import { getCommonRoutes } from './commonRoutes';
import { PrivateRoute } from './PrivateRoute';
import routes from '@/config/routes';

export const getAgentRoutes = (): React.ReactElement[] => {
  const SP_MySchedule = React.lazy(() => import('@/pages/agent/my-schedule'));
  const SP_MyAvailability = React.lazy(() => import('@/pages/agent/my-availability'));
  const SP_ResumeBuilder = React.lazy(() => import('@/pages/agent/resume-builder'));
  const SP_JobListings = React.lazy(() => import('@/pages/agent/job-listings'));
  const SP_TimeOff = React.lazy(() => import('@/pages/agent/time-off'));
  const SP_GigCompliance = React.lazy(() => import('@/pages/agent/gig-compliance'));
  const SP_MyGigs = React.lazy(() => import('@/pages/agent/my-gigs'));
  const SP_JobDescription = React.lazy(() => import('@/pages/agent/job-description'));
  const SP_AppliedGigs = React.lazy(() => import('@/pages/agent/applied-gigs'));
  const SP_Dashboard = React.lazy(() => import('@/pages/agent/dashboard'));
  const SP_Courses = React.lazy(() => import('@/pages/agent/courses'));
  const SP_ClassRegisterComplete = React.lazy(
    () => import('@/components/agent/courses/class-register-complete.component'),
  );
  const SP_Resources = React.lazy(() => import('@/pages/agent/resources'));
  const SP_ResourcePreview = React.lazy(() => import('@/pages/agent/recource-preview'));
  const SP_Learn = React.lazy(() => import('@/pages/agent/learn'));
  const SP_Referral = React.lazy(() => import('@/pages/agent/refer-a-friend'));
  const SP_Community = React.lazy(() => import('@/pages/agent/community'));
  const SP_ExpiredLink = React.lazy(() => import('@/pages/agent/common/expired-link'));

  const items: React.ReactElement[] = [
    <PrivateRoute
      key={routes.sp.scheduling.dashboard}
      path={routes.sp.scheduling.dashboard}
      component={SP_Dashboard}
    />,
    <PrivateRoute
      key={routes.sp.scheduling.mySchedule.index}
      path={routes.sp.scheduling.mySchedule.index}
      component={SP_MySchedule}
    />,
    <PrivateRoute
      key={routes.sp.scheduling.myAvailability.index}
      path={routes.sp.scheduling.myAvailability.index}
      component={SP_MyAvailability}
    />,
    <PrivateRoute
      key={routes.sp.scheduling.timeOff.index}
      path={routes.sp.scheduling.timeOff.index}
      component={SP_TimeOff}
    />,
    <PrivateRoute
      key={routes.sp.onboarding.resumeBuilder}
      path={routes.sp.onboarding.resumeBuilder}
      component={SP_ResumeBuilder}
    />,
    <PrivateRoute
      key={routes.sp.scheduling.myGigs.index}
      path={routes.sp.scheduling.myGigs.index}
      component={SP_MyGigs}
    />,
    <PrivateRoute
      key={routes.sp.scheduling.contract.index}
      path={routes.sp.scheduling.contract.index}
      component={SP_GigCompliance}
    />,
    <PrivateRoute
      key={routes.sp.scheduling.resources.index}
      path={routes.sp.scheduling.resources.index}
      component={SP_Resources}
    />,
    <PrivateRoute
      key={routes.sp.scheduling.resources.previewDatabaseItem}
      path={routes.sp.scheduling.resources.previewDatabaseItem}
      component={SP_ResourcePreview}
    />,
    <PrivateRoute
      key={routes.sp.scheduling.resources.preview}
      path={routes.sp.scheduling.resources.preview}
      component={SP_ResourcePreview}
    />,
    <PrivateRoute key={routes.sp.onboarding.gigs} path={routes.sp.onboarding.gigs} component={SP_JobListings} />,
    <PrivateRoute
      key={routes.sp.onboarding.jobdescription}
      path={routes.sp.onboarding.jobdescription}
      component={SP_JobDescription}
    />,
    <PrivateRoute
      key={routes.sp.onboarding.appliedGigs}
      path={routes.sp.onboarding.appliedGigs}
      component={SP_AppliedGigs}
    />,
    <PrivateRoute key={routes.sp.onboarding.courses} path={routes.sp.onboarding.courses} component={SP_Courses} />,
    <PrivateRoute
      key={routes.sp.onboarding.classRegisterComplete}
      path={routes.sp.onboarding.classRegisterComplete}
      component={SP_ClassRegisterComplete}
    />,
    <PrivateRoute key={routes.sp.learn} path={routes.sp.learn} component={SP_Learn} />,
    <PrivateRoute key={routes.sp.referralProgram} path={routes.sp.referralProgram} component={SP_Referral} />,
    <PrivateRoute key={`common-${routes.sp.community}`} path={routes.sp.community} component={SP_Community} />,
    <PrivateRoute key={`${routes.sp.expiredLink}`} path={routes.sp.expiredLink} component={SP_ExpiredLink} />,
  ];

  getCommonRoutes().forEach(item => items.push(item));
  return items;
};
